export enum TopicEventsType {
  APPLY_SEARCH_CRITERIA = "[Topic Events] - Apply search criteria",
  CLEAR_SEARCH_CRITERIA = "[Topic Events] - Apply clear criteria",
}

export type ApplyEventsSearchCriteriaAction = {
  payload: { limit?: number; offset?: number; search?: string; topicId?: string } & Partial<
    Record<string, string | number>
  >;
  type: TopicEventsType.APPLY_SEARCH_CRITERIA;
};
export type ClearEventsSearchCriteriaAction = { type: TopicEventsType.CLEAR_SEARCH_CRITERIA };
